import React from 'react';
import { useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import { Message } from './components/Message';
import { useChat } from './hooks/useChat';
import { checkUserType } from '../../utils/checkUserType';
import { ListMessage } from './components/ListMessage';
import { InputChat } from './components/InputChat';
import { TitleBlock } from '../TitleBlock';
import { DEF_MARGIN, TYPE_EVENT, TYPE_ID } from '../../utils/consts';
import { EIcons } from '../../utils/globatTypes';
import * as Styles from './styles';

interface GeneralChatProps {}

export const GeneralChat: React.FC<GeneralChatProps> = () => {
  const { loading, sendMessage, likeMessage, handleChangePage } = useChat();
  const Sockets = useSelector((store: AppStore) => store.Sockets);
  const Users = useSelector((store: AppStore) => store.Users);

  if (Sockets.event?.typeEvent !== TYPE_EVENT.ONLINE) {
    return null;
  }

  if (Sockets.room?.type_id === TYPE_ID.WEBINAR && Sockets.room?.isclose === 1) {
    return null;
  }

  return (
    <Styles.WrapperS>
      <div style={{ marginBottom: DEF_MARGIN }}>
        <TitleBlock icon={EIcons.chat} title="Чат" />
      </div>
      {Sockets.room?.pinMessage ? (
        <Message isPinned type={checkUserType(Sockets.room?.pinMessage)} message={Sockets.room?.pinMessage} likeMessage={likeMessage} />
      ) : null}
      <ListMessage user={Users.user} messages={Sockets.chat?.messages} likeMessage={likeMessage} handleChangePage={handleChangePage} />
      <InputChat loading={loading} isEnable={Sockets.room?.type_id !== 3} sendMessage={sendMessage} />
    </Styles.WrapperS>
  );
};
